import { render } from "./checkManage.vue?vue&type=template&id=5d02ec10&scoped=true"
import script from "./checkManage.vue?vue&type=script&lang=js"
export * from "./checkManage.vue?vue&type=script&lang=js"

import "./checkManage.vue?vue&type=style&index=0&id=5d02ec10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d02ec10"

export default script